import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';
import * as _ from 'underscore';

import {ModalSelectorDelegate} from '../../shared';

export class OrgSelectorController implements ModalSelectorDelegate {
   static $inject = ['$q', '$uibModal', 'session'];

   readonly title = 'Select Organizations';
   readonly multiSelect = true;
   readonly templateUrl = 'org-selector-rows.html';

   disabled:boolean;
   selected:number[];
   onSelectedChange:{
      (arg:{$selected:number[]}):void;
   };

   constructor(
      private $q:ng.IQService,
      private $modal:uib.IModalService,
      private session
   ) { }

   open() {
      this.$modal.open({
         component: 'modalSelector',
         resolve: {
            selected: () => this.selected,
            delegate: () => this
         }
      }).result.then(result => this.onSelectedChange({$selected: result}));
   }

   get buttonText():string {
      if (this.selected && this.selected.length > 0) {
         return `${this.selected.length} Orgs Selected`;
      }

      return this.title;
   }

   load(search:string):ng.IPromise<{total:number, list:any[]}> {
      let orgs = this.session.getOrgs() as any[];

      if (search) {
         search = search.toLowerCase();
         let words = _.reject(search.split(' '), w => w === '');
         orgs = _.filter(orgs, org => {
            return _.every(words, w => org.name.toLowerCase().indexOf(w) >= 0);
         });
      }

      return this.$q.resolve({total: orgs.length, list: orgs});
   }
}

ng.module('e360').component('orgSelector', {
   templateUrl: require('./org-selector.component.html'),
   controller: OrgSelectorController,
   bindings: {
      disabled: '<',
      selected: '<',
      onSelectedChange: '&'
   }
});
